import * as v from "valibot";
import { createFileRoute } from "@tanstack/react-router";
import { site } from "../config";
import { localisedLinks } from "../seo";

const searchParamsSchema = v.object({
  country: v.optional(v.string()),
  city: v.optional(v.string()),
  startDate: v.optional(v.string()),
  endDate: v.optional(v.string()),
  sort: v.optional(v.string()),
  duration: v.optional(v.string()),
  price: v.optional(v.string()),
  categories: v.optional(v.string()),
});

export const Route = createFileRoute("/$locale/$currency/")({
  component: () => null,
  validateSearch: searchParamsSchema,
  head: ({ match, params }) => ({
    meta: [
      { title: site.title },
      { name: "description", content: site.description },
    ],
    links: localisedLinks(match.pathname, params.locale, params.currency),
  }),
});
